import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
    const { t } = useTranslation();
    const footerSections = [
        {
            title: t('footer.contact.title'),
            content: [
                t('footer.contact.address1'),
                t('footer.contact.address2'),
                t('footer.contact.zipcode') + ' ' + t('footer.contact.city'),
                t('footer.contact.email')
            ],
            isText: true
        },
        {
            title: t('footer.services.title'),
            class: "footer-hide",
            content: [
                { text: t('footer.services.impactscore'), url: "https://psinfoodservice.com/ps-impact-score/" },
                { text: t('footer.services.producers'), url: "https://psinfoodservice.com/producenten/" },
                { text: t('footer.services.wholesalers'), url: "https://psinfoodservice.com/groothandels/" },
                { text: t('footer.services.customers'), url: "https://psinfoodservice.com/afnemers/" }
            ],
            isLinks: true
        },
        {
            title: t('footer.information.title'),
            class: "footer-hide",
            content: [
                { text: t('footer.information.faq'), url: "/explanation", internal: true },
                { text: t('footer.information.contact'), url: "/helpdesk", internal: true }
            ],
            isLinks: true
        },
        {
            title: t('footer.inspiration.title'),
            class: "footer-hide",
            content: [
                t('footer.inspiration.content')
            ],
            isText: true
        }
    ];

    const renderContent = (section) => {
        if (section.isText) {
            return section.content.map((text, idx) => (
                <React.Fragment key={idx}>
                    {text}<br />
                </React.Fragment>
            ));
        }

        if (section.isLinks) {
            return section.content.map((link, idx) => (
                <React.Fragment key={idx}>
                    {link.internal ? (
                        <a
                            href={link.url}
                            target="_self"
                            rel="noreferrer"
                            className="hover:text-ps-orange block mb-2"
                        >
                            {link.text}
                        </a>
                    ) : (
                        <a
                            href={link.url}
                            target="_blank"
                            rel="noreferrer"
                            className="hover:text-ps-orange block mb-2"
                        >
                            {link.text}
                        </a>
                    )}
                </React.Fragment>
            ));
        }
    };

    return (
        <footer className="bg-ps-gray py-6 footer-container">
            <div className="h-[10px] line-background-bottom" />
            <div className="max-w-[1100px] mx-auto px-4">
                {/* Grid container */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 text-white">
                    {footerSections.map((section, index) => (
                        <div
                            key={index}
                            className={`pt-8 ${section.class || ''}`}
                        >
                            <h3 className="text-lg font-medium mb-4">
                                {section.title}
                            </h3>
                            <div className="text-sm leading-6">
                                {renderContent(section)}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </footer>
    );
};

export default Footer;